module.exports = __webpack_public_path__ + "static/media/logo.45f00e20.png";